var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.963,
    height: 126.989,
    viewBox: "0 0 113.963 126.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13123",
    "data-name": "Group 13123",
    transform: "translate(-2436.231 -1462.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M105.082,5.762H.881A4.881,4.881,0,0,1,.881-4h104.2a4.881,4.881,0,1,1,0,9.762Z",
    transform: "translate(2440.231 1492.969)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13122",
    "data-name": "Group 13122",
    transform: "translate(2442.743 1462.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M.881,44.809A4.881,4.881,0,0,1-4,39.928V.881a4.881,4.881,0,0,1,9.762,0V39.928A4.881,4.881,0,0,1,.881,44.809Z",
    transform: "translate(36.109 56.455)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_39",
    "data-name": "Line 39",
    d: "M.881,44.809A4.881,4.881,0,0,1-4,39.928V.881a4.881,4.881,0,0,1,9.762,0V39.928A4.881,4.881,0,0,1,.881,44.809Z",
    transform: "translate(62.954 56.455)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M77.519,103.938h-52.1A17.926,17.926,0,0,1,7.513,86.032L1.017,8.286a4.881,4.881,0,0,1,9.728-.811l6.513,78.151a8.274,8.274,0,0,0,8.161,8.55h52.1a8.154,8.154,0,0,0,8.144-8.144L92.193,7.476a4.881,4.881,0,0,1,9.728.811L95.409,86.437A17.82,17.82,0,0,1,77.519,103.938Z",
    transform: "translate(-1 23.05)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M48.956,34.812a4.881,4.881,0,0,1-4.881-4.881V10.393a1.634,1.634,0,0,0-1.632-1.632H16.393a1.634,1.634,0,0,0-1.632,1.632V29.931a4.881,4.881,0,1,1-9.762,0V10.393A11.406,11.406,0,0,1,16.393-1h26.05A11.406,11.406,0,0,1,53.837,10.393V29.931A4.881,4.881,0,0,1,48.956,34.812Z",
    transform: "translate(21.051 1)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.9d5f88767906752a077b30722d6c7cad.svg";
export { ForwardRef as ReactComponent };